// Ported from dev-scrips-pm-react services/scheduling/use-flag-list.ts (PROD-1190 calendar port)
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { FlagListResponse } from '@/types/scheduling-api';

export function useFlagList() {
  return useQuery({
    queryKey: ['flag-list'],
    queryFn: ({ signal }) =>
      get<FlagListResponse[]>('/api/Appointment/GetFlagList?searchText=', { signal }),
  });
}
